import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();

const t = block_translation;

export class CollideStartBlock extends AbstractBlock {
  constructor() {
    super('collide-start', t.to('', 'collide_title1'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setElementWithSubBlockShape(block);
    ColorSettings.setPhysicsSystemColor(block);
    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.setSceneStartShape(block);
    const hereId = new Blockly.FieldTextInput('block1');
    const targetId = new Blockly.FieldTextInput('target');
    block
      .appendDummyInput()
      .appendField(`${t.to('ID', 'collide_title2')} [`)
      .appendField(hereId, 'hereId')
      .appendField(`]${t.to('がぶつかった時に、相手のIDを', 'collide_title3')}[`)
      .appendField(targetId, 'targetId')
      .appendField(`]${t.to('にセット', 'collide_title4')}`);

    // ShapeSettings.addAttributeInput(block);
    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    // attribute = CodeSetting.getSubAttributeCode(block);
    const hereId = CodeSetting.getFieldValue(block, 'hereId');
    const targetId = CodeSetting.getFieldValue(block, 'targetId');
    const targetInstance = `ready(async()=>{ document.getElementById('${hereId}')`;
    const sub = CodeSetting.getSubstatementCode(block);
    const str = `
    ${targetInstance}.addEventListener("collidestart",(e)=>{
			let ${targetId} = e.detail.targetEl.id;
      let parent = document.querySelector("a-scene");
			${sub}
		})
  });`;
    return str;
  }
}
